import {
  Youtube,
  Facebook,
  Instagram,
  Twitter,
  ExternalLink,
} from "lucide-react";

const snsLinks = [
  {
    name: "유튜브",
    icon: Youtube,
    url: "https://www.youtube.com/@liztv1858",
    color: "#FF0000",
    followers: "30만+",
    description: "연애 꿀팁 영상",
  },
  {
    name: "인스타그램",
    icon: Instagram,
    url: "https://www.instagram.com/liztv7/",
    color: "#E4405F",
    followers: "5만+",
    description: "일상 & 이벤트",
  },
  {
    name: "페이스북",
    icon: Facebook,
    url: "https://www.facebook.com/elizabeth.son.5817",
    color: "#1877F2",
    followers: "2만+",
    description: "커뮤니티 소식",
  },
  {
    name: "X (트위터)",
    icon: Twitter,
    url: "https://twitter.com/NewCoupling",
    color: "#000000",
    followers: "1만+",
    description: "실시간 소식",
  },
  {
    name: "스레드",
    icon: ({ className }) => (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.96-.065-1.182.408-2.256 1.333-3.022.812-.672 1.927-1.072 3.222-1.153 1.009-.063 1.949.033 2.818.272-.069-.782-.262-1.398-.583-1.846-.46-.642-1.183-.955-2.212-.955h-.063c-.834.015-1.506.27-1.998.757l-1.399-1.476c.847-.807 1.965-1.237 3.327-1.28h.082c1.717 0 3.063.58 4.004 1.726.853 1.038 1.303 2.5 1.34 4.35.303.153.588.324.855.513 1.164.82 1.978 1.9 2.355 3.123.548 1.766.324 4.13-1.548 6.05-1.87 1.918-4.275 2.723-7.37 2.745zm-1.565-7.61c-.882.053-1.57.317-1.99.763-.36.38-.536.864-.508 1.4.03.57.322 1.09.825 1.417.577.374 1.352.549 2.18.502 1.104-.06 1.95-.479 2.515-1.248.361-.49.612-1.104.748-1.833-.814-.228-1.73-.341-2.72-.341-.352 0-.71.017-1.05.04z"/>
      </svg>
    ),
    url: "https://www.threads.com/@liztvhealingcafe",
    color: "#000000",
    followers: "1만+",
    description: "트렌디한 소통",
  },
  {
    name: "네이버 블로그",
    icon: ({ className }) => (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M16.273 12.845L7.376 0H0v24h7.726V11.156L16.624 24H24V0h-7.727v12.845z"/>
      </svg>
    ),
    url: "https://blog.naver.com/elizabeth3080",
    color: "#03C75A",
    followers: "1000+",
    description: "깊이있는 콘텐츠",
  },
  {
    name: "틱톡",
    icon: ({ className }) => (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
      </svg>
    ),
    url: "https://www.tiktok.com/@liztvcanada",
    color: "#000000",
    followers: "1.5만+",
    description: "숏폼 연애팁",
  },
  {
    name: "구글 블로그",
    icon: ({ className }) => (
      <svg className={className} viewBox="0 0 24 24" fill="currentColor">
        <path d="M21.976 24H2.024C.908 24 0 23.092 0 21.976V2.024C0 .908.908 0 2.024 0h19.952C23.092 0 24 .908 24 2.024v19.952C24 23.092 23.092 24 21.976 24zM12 3.819c-4.518 0-8.181 3.664-8.181 8.181 0 4.518 3.663 8.181 8.181 8.181 4.518 0 8.181-3.663 8.181-8.181 0-4.517-3.663-8.181-8.181-8.181zm3.792 11.659H8.208a.275.275 0 01-.275-.275v-1.19a.275.275 0 01.275-.275h3.025V10.5H8.208a.275.275 0 01-.275-.275V9.034a.275.275 0 01.275-.275h7.584a.275.275 0 01.275.275v5.894a.275.275 0 01-.275.275z"/>
      </svg>
    ),
    url: "https://www.blogger.com/blog/posts/4853560346427716422?bpli=1&pli=1",
    color: "#FF5722",
    followers: "500+",
    description: "블로그 콘텐츠",
  },
];

export const SNSSection = () => {
  return (
    <section
      id="sns"
      className="py-14 lg:py-20 bg-[#FAFAF9] relative overflow-hidden"
      data-testid="sns-section"
    >
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span
            className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-4 block"
            data-testid="sns-label"
          >
            Follow Us
          </span>
          <h2
            className="font-sans text-3xl md:text-4xl lg:text-5xl font-[720] text-stone-800 mb-6"
            data-testid="sns-title"
          >
            SNS에서
            <br />
            <span className="text-burgundy-500">Liz를 만나보세요</span>
          </h2>
          <div className="w-16 h-1 bg-gold-400 mx-auto mb-6" />
          <p
            className="text-stone-600 text-base md:text-lg"
            data-testid="sns-description"
          >
            다양한 채널에서 연애 꿀팁과 이벤트 소식을 확인하세요!
          </p>
        </div>

        {/* SNS Marquee */}
        <div className="overflow-hidden" data-testid="sns-grid">
          <div className="flex animate-marquee gap-6">
            {/* First set */}
            {snsLinks.map((sns, index) => (
              <a
                key={`first-${sns.name}`}
                href={sns.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex-shrink-0 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 text-center hover:bg-white/20 transition-all duration-300 hover:-translate-y-1 w-40"
                data-testid={`sns-link-${index}`}
              >
                {/* Icon */}
                <div
                  className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: sns.color }}
                >
                  <sns.icon className="w-6 h-6 text-white" />
                </div>

                {/* Name */}
                <h3
                  className="font-semibold text-white text-sm mb-1"
                  data-testid={`sns-name-${index}`}
                >
                  {sns.name}
                </h3>

                {/* Followers */}
                <div className="text-gold-300 text-xs font-medium mb-2">
                  {sns.followers} 팔로워
                </div>

                {/* Description */}
                <p className="text-white/60 text-xs hidden md:block">
                  {sns.description}
                </p>
              </a>
            ))}
            {/* Duplicate set for seamless loop */}
            {snsLinks.map((sns, index) => (
              <a
                key={`second-${sns.name}`}
                href={sns.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex-shrink-0 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 text-center hover:bg-white/20 transition-all duration-300 hover:-translate-y-1 w-40"
              >
                {/* Icon */}
                <div
                  className="w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: sns.color }}
                >
                  <sns.icon className="w-6 h-6 text-white" />
                </div>

                {/* Name */}
                <h3 className="font-semibold text-white text-sm mb-1">
                  {sns.name}
                </h3>

                {/* Followers */}
                <div className="text-gold-300 text-xs font-medium mb-2">
                  {sns.followers} 팔로워
                </div>

                {/* Description */}
                <p className="text-white/60 text-xs hidden md:block">
                  {sns.description}
                </p>
              </a>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-white/70 text-sm">
            모든 SNS 채널 총 <span className="text-gold-300 font-bold">45만+</span> 팔로워와 함께합니다
          </p>
        </div>
      </div>
    </section>
  );
};
